module.exports = __webpack_public_path__ + "static/media/img_default.6e4a565d.png";